module.exports = __webpack_public_path__ + "img/facebook.7327ce11.svg";